export default __webpack_public_path__ + "static/media/Exclamation.d4829e88.svg";